import httpClient from '../httpClient';
import type {
  MemberProfile,
  MemberOverviewStats,
  MemberCourse,
  MemberAssessment,
  MemberCertificate,
  MemberLearningHours,
} from './OrganizationMemberActivityService';

export interface LearnerRow {
  uuid: string;
  name: string;
  email: string;
  organizations: string;
}

export interface LearnersPage {
  learners: LearnerRow[];
  pagination: { total: number; page: number; limit: number; totalPages: number };
}

export interface FullTranscript {
  profile: MemberProfile;
  stats: MemberOverviewStats;
  courses: MemberCourse[];
  assessments: MemberAssessment[];
  certificates: MemberCertificate[];
  learningHours: MemberLearningHours;
}

interface ApiResponse<T> { success: boolean; data: T; message?: string; }

const BASE = '/super-admin/transcripts';

const ok = <T,>(data?: T) => ({ success: true as const, data, error: null as { message: string } | null });
const fail = (e: any) => ({ success: false as const, data: undefined, error: { message: e?.response?.data?.message ?? e?.message ?? 'Request failed' } });

export const getLearners = async (params: { orgId?: number | null; search?: string; page?: number; limit?: number } = {}) => {
  try {
    const qp = new URLSearchParams();
    if (params.orgId) qp.append('orgId', String(params.orgId));
    if (params.search) qp.append('search', params.search);
    qp.append('page', String(params.page || 1));
    qp.append('limit', String(params.limit || 20));
    const res = await httpClient.get<ApiResponse<LearnersPage>>(`${BASE}/learners?${qp.toString()}`);
    return ok(res.data);
  } catch (e) { return fail(e); }
};

export const getTranscript = async (userId: string) => {
  try {
    const res = await httpClient.get<ApiResponse<FullTranscript>>(`${BASE}/${userId}/full`);
    return ok(res.data);
  } catch (e) { return fail(e); }
};

export const getBulkTranscripts = async (orgId: number) => {
  try {
    const res = await httpClient.get<ApiResponse<{ transcripts: FullTranscript[]; truncated: boolean }>>(`${BASE}/bulk?orgId=${orgId}`);
    return ok(res.data);
  } catch (e) { return fail(e); }
};
